import { call, put, type SagaReturnType, takeEvery } from 'redux-saga/effects'
import {
    requestFetchAreas,
    fetchAreasStart,
    fetchAreasSuccess,
    fetchAreasFailed,
    fetchSubZonesStart,
    fetchSubZonesSuccess,
} from 'src/redux/zoneAreas'
import { getAreasByZoneId, getSubZonesByZoneId } from 'src/api'

type GetAreasByZoneId = SagaReturnType<typeof getAreasByZoneId>

export function* handleRequestFetchAreas(action: ReturnType<typeof requestFetchAreas>) {
    yield put(fetchAreasStart())
    const zoneId = action.payload

    const areas: GetAreasByZoneId = yield call(getAreasByZoneId, zoneId)
    if (areas instanceof Error) {
        yield put(fetchAreasFailed())
    } else {
        yield put(fetchAreasSuccess(areas))
    }
}

export function* handleRequestFetchSubZones(action: ReturnType<typeof requestFetchAreas>) {
    yield put(fetchSubZonesStart())
    const zoneId = action.payload

    const subZones: SagaReturnType<typeof getSubZonesByZoneId> = yield call(getSubZonesByZoneId, zoneId)
    yield put(fetchSubZonesSuccess(subZones))
}

export default function* watcher() {
    yield takeEvery(requestFetchAreas.toString(), handleRequestFetchAreas)
    yield takeEvery(requestFetchAreas.toString(), handleRequestFetchSubZones)
}
